import React from "react";
import {PROCESS_TEXT_JUSTIFICATION} from "../../scripts/layout-manager";
import PopoverTooltip from "../PopoverTooltip";

export default function QuestionFootnote(props) {
  const {question} = props;
  
  let text = question.footnote?.text;
  let textJustification = PROCESS_TEXT_JUSTIFICATION(question.footnote?.justification)

  return (
    <>
    {text && (
      <div className={`footnote ${textJustification}`}>
        {text}
        {
            question.footnote?.info && (
                <>
                  &nbsp;
                  <PopoverTooltip
                      title={question.footnote?.info.title}
                      content={question.footnote?.info.content} />
                </>
            )
        }      </div>
    )}
    </>
  )
}